<template>
  <span v-if="state" class="draft-badge" @click.stop>
    <!-- TKP-104 / md. 13, 15 — kayıt taslakta (kendi düzenlemem) ya da kilitli (başkasının taslağında) -->
    <b-badge :id="badgeId" :variant="state.mine ? 'info' : 'secondary'" class="ml-1" :data-test="state.mine ? 'draft' : 'locked'">
      <i :class="state.mine ? 'bx bx-edit' : 'bx bx-lock-alt'"></i>
      {{ state.mine ? $t(state.packageStatus === "SUBMITTED" ? "approval.badge.submitted" : "approval.badge.draft") : $t("approval.badge.locked") }}
    </b-badge>
    <b-popover :target="badgeId" triggers="hover" placement="top">
      <template v-if="state.mine">
        <div v-for="row in rows" :key="row.field" class="small"><code>{{ fieldLabel(row.field) }}</code>: <span class="text-muted">{{ row.before }}</span> → <strong>{{ row.after }}</strong></div>
        <div v-if="rows.length === 0" class="small text-muted">{{ $t(`approval.operation.${state.edit.operation}`) }}</div>
      </template>
      <div v-else class="small">{{ $t("approval.badge.locked-by", { name: state.authorName || "—" }) }}<br />{{ $t("approval.badge.locked-hint") }}</div>
    </b-popover>
  </span>
</template>

<script>
import { draftStateOf, fieldLabelKey, summarize } from "./approval";

export default {
  name: "draft-badge",
  props: { entityType: { type: String, required: true }, entityId: { type: [String, Number], required: true } },
  computed: {
    enabled() {
      const status = this.$store.getters["approval/status"];
      return !!(status && status.enabled);
    },
    state() {
      if (!this.enabled) return null; // onay kapalıyken ekranlar bugünkü gibi (kriter 3)
      return draftStateOf(this.$store.getters["approval/drafts"], this.entityType, this.entityId, this.currentAccount && this.currentAccount._id);
    },
    rows() {
      return this.state ? summarize(this.state.edit) : [];
    },
    badgeId() {
      return `draft-badge-${this.entityType}-${this.entityId}`;
    },
  },
  methods: {
    // TKP-131: onay ekranıyla aynı etiket ("Veri kaynakları"), ham alan kodu ("datasources") değil
    fieldLabel(field) {
      const key = fieldLabelKey(field);
      return this.$te && this.$te(key) ? this.$t(key) : field;
    },
  },
};
</script>
